import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

/**
 * PD-16919 — when a user last opened a report, for the Recently Used list on
 * the Reporting home page. Kept on the server, per tenant user, so the list
 * follows the user across devices and the mobile app.
 *
 * `reportKey` is the same key ReportFavoriteEntity uses. One row per
 * (user, report): opening a report again moves its date forward rather than
 * adding a row. Only the user's most recent ten stay live; older ones are
 * soft-deleted when a view is recorded, and recovered if that report is
 * opened again, so the unique key is never violated.
 *
 * Not audited: a row is written every time a report page opens, and an
 * `_audit` row for each would be noise that says nothing about the data.
 */
@Index('idx_report_view_user_report', ['fkUserId', 'reportKey'], {
	unique: true,
})
@Index('idx_report_view_user_viewed', ['fkUserId', 'lastViewedDate'], {})
@Entity('report_view', {}, { auditable: false })
export class ReportViewEntity extends BaseEntity {
	/** Tenant-local `user._id`, the id the session's instance user carries. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: 'reportKey', length: 255 })
	public reportKey!: string;

	@Column('datetime', { name: 'lastViewedDate' })
	public lastViewedDate!: Date;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public user!: UserEntity;
}
